import {Component, Input, OnInit} from '@angular/core';
import {Pessoa} from '../pessoa/pessoa.model';
import {MensagemService, ProgressoService, Restricao, RestricaoOperador, Restricoes} from 'maestro-ng';
import {PessoaEnderecoEletronicoService} from './pessoa-endereco-eletronico.service';
import {PessoaEnderecoEletronico} from './pessoa-endereco-eletronico.model';
import {DataSourceRouted} from '../util/data-source-routed';
import {ActivatedRoute, Router} from '@angular/router';
import {SelectItem} from 'primeng/api';
import {SelectItemService} from '../services/select-item.service';

@Component({
  selector: 'app-pessoa-endereco-eletronico',
  templateUrl: './pessoa-endereco-eletronico.component.html',
  styleUrls: ['../pessoa/pessoa-visualizacao/pessoa-visualizacao.component.css']
})
export class PessoaEnderecoEletronicoComponent implements OnInit {

  @Input()
  pessoa: Pessoa;

  public dsEnderecosEletronicos: DataSourceRouted<PessoaEnderecoEletronico, number>;
  public pessoaEnderecoEletronicoTipoItens: SelectItem[];

  constructor(
    private pessoaEnderecoEletronicoService: PessoaEnderecoEletronicoService,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private selectItemService: SelectItemService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    this.pessoaEnderecoEletronicoTipoItens = this.selectItemService.getPessoaEnderecoEletronicoTipo();
  }

  public carregarEnderecosEletronico(): void {
    if ((!this.pessoa.enderecosEletronicos || !this.pessoa.enderecosEletronicos.length)) {
      this.progressoService.modeless();
      if (this.dsEnderecosEletronicos === undefined) {
        this.dsEnderecosEletronicos = new DataSourceRouted<PessoaEnderecoEletronico, number>(
          'pessoa-endereco-eletronico',
          (c) => this.pessoaEnderecoEletronicoService.recuperarPaginadoPorPessoaId(this.pessoa.id, c),
          this.mensagemService, this.progressoService,
          this.route,
          this.router,
          100,
          new Restricoes(
            [
              new Restricao<number>({atributo: 'id', operador: RestricaoOperador.EQUALS}),
              new Restricao<string>({atributo: 'origemId', operador: RestricaoOperador.EQUALS}),
              new Restricao<string>({atributo: 'enderecoEletronico.endereco', operador: RestricaoOperador.CONTAINS}),
              new Restricao<string>({atributo: 'enderecoEletronico.tipo', operador: RestricaoOperador.EQUALS})
            ]
          )
        );
      }
    }
    else {
      this.dsEnderecosEletronicos.pesquisar();
    }
    this.progressoService.fechar();
  }
}
